import { MultiValuedList } from '../../MultiValuedList'
import { TableCellBase, TableEmptyCell } from '../../Table'

import {
  EMAIL_TABLE_ROW_ACTIVITIES_DROPDOWN_STYLES,
  EMAIL_TABLE_ROW_ACTIVITIES_VISIBLE_COUNT,
} from './EmailTableRowActivities.constants'
import {
  filterActivityByLabel,
  getEmailTableRowActivityItems,
} from './EmailTableRowActivities.utils'
import { EmailTableRowActivitiesItem } from './EmailTableRowActivitiesItem'
import { EmailTableRowActivitiesMoreItem } from './EmailTableRowActivitiesMoreItem'

import * as styles from './EmailTableRowActivities.module.css'

function EmailTableRowActivities({ item, scrollRef, ...cellProps }) {
  const { activities } = item

  const items = getEmailTableRowActivityItems(activities)

  return items.length > 0 ? (
    <TableCellBase {...cellProps}>
      <MultiValuedList
        Item={EmailTableRowActivitiesItem}
        MoreItem={EmailTableRowActivitiesMoreItem}
        className={styles.list}
        filter={filterActivityByLabel}
        items={items}
        itemsCount={items.length}
        moreProps={{
          containerRef: scrollRef,
          dropdownStyles: EMAIL_TABLE_ROW_ACTIVITIES_DROPDOWN_STYLES,
        }}
        visibleCount={EMAIL_TABLE_ROW_ACTIVITIES_VISIBLE_COUNT}
      />
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} />
  )
}

export default EmailTableRowActivities
